<template>
    <div class="sheetPage">
        <div class="header">
            <headerNotice routerName="电子面单"></headerNotice>
            <el-row class="printBtn" :gutter="24" style="margin-top:20px;">
                <el-col :span="2">
                    <el-button type="info" @click="back">返回</el-button>
                </el-col>
                <!-- <el-col :span="4" :offset="5">
                    <el-button type="primary" id="myPreview3" @click="printSystem">系统打印</el-button>
                </el-col>-->
                <el-col :span="4" :offset="6">
                    <a
                        class="printDownload"
                        href="/CNPrintSetup.exe"
                        download="CNPrintSetup.exe"
                    >下载菜鸟打印插件</a>
                </el-col>
            </el-row>
        </div>
        <!-- <div class="printSetting">
            <p style="font-size:24px;margin:20px;">打印配置:</p>
            <p style="margin:10px 40px;">
                1：选择如下打印机：
                <input
                    type="radio"
                    id="Radio1"
                    name="RadioS1"
                    :checked="printMac==1"
                    @click="choosePrint(1)"
                >默认打印机
                <input
                    type="radio"
                    id="Radio2"
                    name="RadioS1"
                    :checked="printMac==2"
                    @click="choosePrint(2)"
                >指定打印机:
                <select id="PrinterList" size="1" v-if="printMac==2" v-model="printMacType">
                    <option
                        v-for="(item, index) in printMacNameList"
                        :key="index"
                        :value="index"
                    >{{item}}</option>
                </select>
            </p>
            <p style="margin:10px 40px;">
                2：用宽
                <input type="text" size="5" id="W4" v-model="pageWidth">(mm)
                <br>&nbsp;&nbsp; 高
                <input type="text" size="5" id="H4" v-model="pageHeight">(mm)进行
                <el-button type="primary" id="myPreview3" @click="printPre">插件预览打印</el-button>
                <el-button type="primary" id="myPreview3" @click="printNow">插件直接打印</el-button>
            </p>
        </div>-->
        <div class="printSetting">
            <p style="font-size:24px;margin:20px;">打印配置:</p>
            <p style="margin:10px 40px;">
                1：选择如下打印机：
                <input
                    type="radio"
                    id="Radio1"
                    name="RadioS1"
                    :checked="printType==1"
                    @click="choosePrint(1)"
                >默认打印机
                <input
                    type="radio"
                    id="Radio2"
                    name="RadioS1"
                    :checked="printType==2"
                    @click="choosePrint(2)"
                >指定打印机:
                <select
                    id="PrinterList"
                    size="1"
                    v-if="printType==2"
                    v-model="currentPrinter"
                >
                    <option
                        v-for="(item, index) in printMachineList"
                        :key="index"
                        :value="item.name"
                    >{{item.name}}</option>
                </select>
            </p>
            <p style="margin:10px 40px;">
                2：配置及打印：
                <el-button type="primary" @click="doPrinterConfig">配置打印机协议</el-button>
                <el-button type="primary" @click="doPrePrint">预览打印</el-button>
                <el-button type="primary" @click="doPrint">开始打印</el-button>
            </p>
        </div>
        <div id="pdfDiv" align="middle">
            <iframe id="pdf" src width="100%" height="100%"></iframe>
        </div>
        <div class="logList">
            <h3>日志列表</h3>
            <textarea
                cols="80"
                rows="20"
                id="resultMessage"
                name="resultMessage"
                readonly="readonly"
            ></textarea>
        </div>
        <!-- <script id="scriptTxt" type=text/html >
            // 电子订单页面
            .sheetDom {
                margin: 20px 0px;
                margin-right: 15%;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding-top: 50px;
                font-family: "微软雅黑" !important;
            }
            .sheetDom /deep/ .sheetList {
                margin-bottom: 170px;
            }
            /deep/ .print_paper.table_first td {
                position: static !important;
            }
        </script>-->
        <!-- 电子订单页面 -->
        <div class="sheetDom" id="sheetDomBox" v-loading="loading"></div>
    </div>
</template>
<script>
import headerNotice from './../../components/common/headerNotice.vue'


import printJS from 'print-js'
let LODOP = getLodop();
export default {
    data() {
        return {
            loading: false,
            sheetDoms: '',
            pageWidth: 990,//纸张宽
            pageHeight: 1480,//纸张高
            printMac: 1,//打印机状态 默认  选择
            printMacNameList: [],//打印机列表
            printMacType: 1,//打印机类型
            socket: null,
            printType: 1,
            printMachineList: [],//打印机器列表
            currentPrinter: 'Microsoft Print to PDF',
            defaultPrinter: 'Microsoft Print to PDF',
            printData: null,//打印数据
            logList: [],
        }
    },
    components: {
        headerNotice
    },
    created() {
        if (localStorage.getItem('defaultElePrintProps')) {
            let defaultPrintProps = JSON.parse(localStorage.getItem('defaultElePrintProps'));
            this.pageWidth = defaultPrintProps.pageWidth;
            this.pageHeight = defaultPrintProps.pageHeight;
            this.printMac = defaultPrintProps.printMac;
            this.printMacType = defaultPrintProps.printMacType;
        }
    },
    mounted() {
        this.orderIDArr = sessionStorage.getItem('orderIDArr');
        this.orderIDArr = this.orderIDArr.split(',')
        this.getDatas();
        if (LODOP) {
            this.CreatePrinterList();
        }
        // this.connectSocket()
    },
    methods: {
        //获取数据
        getDatas() {
            let self = this;
            self.loading = true;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminOrder/PrintElectronicOrder",
                data: {
                    orderIDs: this.orderIDArr
                },
                success(res) {
                    let JSONRes = [];
                    res.forEach((ele, index) => {
                        JSONRes.push(JSON.parse(ele))
                    })
                    self.printData = JSONRes;
                    self.connectSocket()

                    // let sheetDomBox = document.getElementById('sheetDomBox');
                    // let sheetListDiv = ''
                    // res.forEach((ele, index) => {
                    //     sheetListDiv += '<div class="sheetList">' + ele + '</div>'
                    // })
                    // sheetDomBox.innerHTML = sheetListDiv;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        //预览打印
        printPre() {
            let self = this;
            try {
                if (LODOP.VERSION) {
                    let scriptTxt = document.getElementById("scriptTxt").innerHTML;
                    let strFormHtml = '<style>' + scriptTxt + '</style>' + document.getElementById("sheetDomBox").innerHTML;
                    LODOP.PRINT_INIT("电子面单");
                    if (this.printMac == 1) {
                        LODOP.SET_PRINTER_INDEX(-1);
                    } else {
                        LODOP.SET_PRINTER_INDEX(this.printMacType);//选择打印机
                    }
                    LODOP.SET_PRINT_PAGESIZE(1, Number(this.pageWidth), Number(this.pageHeight), "CreateCustomPage");
                    LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', strFormHtml);//添加打印内容
                    LODOP.SET_PRINT_MODE("POS_BASEON_PAPER", true);
                    LODOP.PREVIEW();
                    let params = {
                        pageWidth: this.pageWidth,
                        pageHeight: this.pageHeight,
                        printMac: this.printMac,
                        printMacType: this.printMacType,
                    }
                    localStorage.setItem('defaultElePrintProps', JSON.stringify(params));
                };
            } catch (err) {
                alert("本机未安装Lodop控件！\n 请先下载安装！");
                window.location.reload();
            }
        },
        //直接打印
        printNow() {
            let self = this;
            try {
                if (LODOP.VERSION) {
                    let scriptTxt = document.getElementById("scriptTxt").innerHTML;
                    let strFormHtml = '<style>' + scriptTxt + '</style>' + document.getElementById("sheetDomBox").innerHTML;
                    LODOP.PRINT_INIT("电子面单");
                    if (this.printMac == 1) {
                        LODOP.SET_PRINTER_INDEX(-1);
                    } else {
                        LODOP.SET_PRINTER_INDEX(this.printMacType);//选择打印机
                    }
                    LODOP.SET_PRINT_PAGESIZE(1, Number(this.pageWidth), Number(this.pageHeight), "CreateCustomPage");
                    LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', strFormHtml);//添加打印内容
                    LODOP.SET_PRINT_MODE("POS_BASEON_PAPER", true);
                    LODOP.PRINT();
                    let params = {
                        pageWidth: this.pageWidth,
                        pageHeight: this.pageHeight,
                        printMac: this.printMac,
                        printMacType: this.printMacType,
                    }
                    localStorage.setItem('defaultElePrintProps', JSON.stringify(params));
                };
            } catch (err) {
                alert("本机未安装Lodop控件！\n 请先下载安装！");
                window.location.reload();
            }
        },
        choosePrint(val) {
            this.printMac = val;
            this.printType = val;
        },
        //创建打印机列表
        CreatePrinterList() {
            let iPrinterCount = LODOP.GET_PRINTER_COUNT();
            this.printMacNameList = [];
            for (var i = 0; i < iPrinterCount; i++) {
                this.printMacNameList.push(LODOP.GET_PRINTER_NAME(i));
            };
        },
        //系统打印
        printSystem() {
            printJS({
                printable: 'sheetDomBox',
                type: 'html',
                // 继承原来的所有样式
                targetStyles: ['*']
            })
        },
        //返回
        back() {
            this.$router.back();
        },
        //链接socket服务器   菜鸟订单
        connectSocket() {
            let self = this;
            this.socket = new WebSocket("ws://127.0.0.1:13528");
            this.socket.onopen = function (event) {
                //获取打印机列表
                self.doGetPrinters();
                // 监听消息
                self.socket.onmessage = function (event) {
                    //预览打印
                    var obj = eval('(' + event.data + ')');
                    if (obj && (obj.previewURL || obj.previewImage)) {
                        var url;
                        if (obj && obj.previewURL) {
                            url = obj.previewURL;
                        } else if (obj && obj.previewImage) {
                            url = obj.previewImage;
                        }
                        var pdf = document.getElementById('pdf');
                        pdf.setAttribute('src', url);
                    }
                    var resultElement = document.getElementById("resultMessage");
                    resultElement.value = resultElement.value + event.data + "\n" + "\n";
                    resultElement.scrollTop = resultElement.scrollHeight;
                    var data = JSON.parse(event.data);
                    if ("getPrinters" == data.cmd) {
                        self.printMachineList = data.printers;
                        if (localStorage.getItem('defaultCaiNiaoPrinter')) {
                            self.currentPrinter = localStorage.getItem('defaultCaiNiaoPrinter');
                            self.defaultPrinter = localStorage.getItem('defaultCaiNiaoPrinter');
                        } else {
                            self.currentPrinter = data.defaultPrinter;
                            self.defaultPrinter = data.defaultPrinter;
                        }
                    }
                    else {
                        console.log("返回数据:" + JSON.stringify(data));
                    }

                };
                // 监听Socket的关闭
                self.socket.onclose = function (event) {
                    console.log('Client notified socket has closed', event);
                };
            }
        },
        //获取随机id字符串
        getUUID(len, radix) {
            var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
            var uuid = [], i;
            radix = radix || chars.length;
            if (len) {
                for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
            } else {
                var r;
                uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
                uuid[14] = '4';
                for (i = 0; i < 36; i++) {
                    if (!uuid[i]) {
                        r = 0 | Math.random() * 16;
                        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
                    }
                }
            }
            return uuid.join('');
        },
        //获取打印机列表
        doGetPrinters() {
            var request = {
                requestID: this.getUUID(8, 16),
                version: '1.0',
                cmd: 'getPrinters'
            };
            this.socket.send(JSON.stringify(request));
        },
        // 配置打印机协议
        doPrinterConfig() {
            let request = {
                requestID: this.getUUID(8, 16),
                version: '1.0',
                cmd: 'printerConfig'
            };
            this.socket.send(JSON.stringify(request));
            this.doSetPrinterConfig();
        },
        // 打印机配置
        doSetPrinterConfig() {
            var request = {
                requetid: this.getUUID(8, 16),
                version: '1.0',
                cmd: 'setPrinterConfig',
                printer: {
                    name: this.currentPrinter,
                    needUpLogo: true,
                    needDownLogo: false
                }
            };
            this.socket.send(JSON.stringify(request));
        },
        //预览打印
        doPrePrint() {
            this.doPrint('pre');
            document.getElementById("pdfDiv").style.visibility = "visible";
        },
        //直接打印
        doPrint(isPreview) {
            if (this.printType == 1) {
                this.currentPrinter = this.defaultPrinter;
            }
            let printTaskId = new Date().getTime();
            let request = {
                cmd: "print",
                requestID: this.getUUID(8, 16),
                version: "1.0",
                task: {
                    taskID: '' + new Date().getTime(),
                    preview: isPreview == 'pre' ? true : false,
                    printer: this.currentPrinter,
                    "notifyMode": "allInOne",
                    "previewType": "pdf",
                    documents: [
                        {
                            "documentID": "0123456789",
                            contents: this.printData
                        }
                    ]
                }
            };
            this.socket.send(JSON.stringify(request));
            localStorage.setItem('defaultCaiNiaoPrinter', this.currentPrinter)
        }
    },
}
</script>

<style lang='scss' scoped>
.sheetPage {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    .header {
        position: relative;
        .printBtn {
            position: absolute;
            top: -10px;
            right: 20%;
        }
        .printDownload {
            display: inline-block;
            line-height: 1;
            white-space: nowrap;
            cursor: pointer;
            background: #fff;
            border: 1px solid #dcdfe6;
            color: #606266;
            -webkit-appearance: none;
            text-align: center;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            outline: 0;
            margin: 0;
            -webkit-transition: 0.1s;
            transition: 0.1s;
            font-weight: 500;
            padding: 12px 20px;
            font-size: 14px;
            border-radius: 4px;
            color: #fff;
            background-color: #409eff;
            border-color: #409eff;
        }
    }
    // 电子订单页面
    .sheetDom {
        margin: 20px 0px;
        margin-right: 15%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 50px;
        font-family: "微软雅黑" !important;
        /deep/ .sheetList {
            margin-bottom: 170px;
        }
    }
    /deep/ .print_paper.table_first {
        td {
            position: static !important;
        }
    }
    #pdfDiv {
        margin-left: 5%;
        height: 550px;
        width: 40%;
        float: left;
    }
    .logList {
        margin-left: 50px;
        height: 550px;
        float: left;
        width: 40%;
        display: flex;
        flex-direction: column;
        h3 {
            padding: 20px 30px;
            border: 1px solid #000;
            border-bottom: none;
        }
        #resultMessage {
            width: 100%;
            min-height: 480px;
            resize: none;
            appearance: none;
            border-bottom: 1px solid #000;
            outline: none;
        }
    }
}
</style>
